module.exports = __webpack_public_path__ + "static/img/sc04.16f4ddd8.png";